import { create } from 'zustand';

interface ApplicationCountStoreType {
  count: number;
  setCount: (count: number) => void;
}

export const useApplicationCountStore = create<ApplicationCountStoreType>((set) => ({
  count: 0,
  setCount: (count: number) => set({ count }),
}));
